import { render, staticRenderFns } from "./account-nav.vue?vue&type=template&id=373a324a&"
import script from "./account-nav.vue?vue&type=script&lang=js&"
export * from "./account-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports